import PropTypes from 'prop-types';
import React from 'react';

import {
  FloatingStyledDiv,
  NoResultsP,
  OptionButton,
} from './styled-components';

const Option = ({
  option: { id, name, component, isDisabled },
  hoveredOption,
  handleMouseEnter,
  handleSelect,
}) =>
  component
  || (
    <OptionButton
      tabIndex={-1}
      type="button"
      data-option-id={id} // Used to scroll to option based on ID
      $isHovered={hoveredOption === id}
      disabled={isDisabled}
      onMouseEnter={handleMouseEnter}
      onClick={handleSelect}
    >
      {name}
    </OptionButton>
  );

Option.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired,
    component: PropTypes.node,
    isDisabled: PropTypes.bool,
    isLabel: PropTypes.bool,
  }).isRequired,
  hoveredOption: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleMouseEnter: PropTypes.func,
  handleSelect: PropTypes.func.isRequired,
};

export const Dropdown = ({
  options,
  filter,
  hoveredOption,
  handleMouseEnter,
  handleSelect,
}) => {
  return (
    <FloatingStyledDiv>
      {options?.map(option => (
        <Option
          key={option.id}
          option={option}
          hoveredOption={hoveredOption}
          handleMouseEnter={() => handleMouseEnter(option.id)}
          handleSelect={() => handleSelect(option.id)}
        />
      ))}
      {!options?.length
        && <NoResultsP>No results found for "{filter}"</NoResultsP>
      }
    </FloatingStyledDiv>
  );
};

Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  filter: PropTypes.string,
  hoveredOption: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleMouseEnter: PropTypes.func,
  handleSelect: PropTypes.func.isRequired,
};
